module.exports = __webpack_public_path__ + "static/img/doct.66335b7e.jpg";